import { createSelector } from 'reselect'

export const getToastState = (state) => state.mars.toast

export const getToastProps = createSelector([getToastState], (toastState) => toastState.toastProps)
